import { createAction } from 'redux-act';

export const startTrialAction = createAction();
